import React, { Component } from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'
import { colors, fonts, fontSizes, fontWeights } from '../theme'
import { Flex, Box, Text, Divider, Relative } from 'rebass'
import { TagMultipleIcon, AccountIcon, CalendarIcon } from 'mdi-react'
import  Link  from 'gatsby-link';

const Iconlink = styled(Text)`
  list-style: none;
  text-align: left;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #7f97ad;
  font-family: ${fonts.secondary};
  font-size: ${fontSizes[2] + 'px'};
`
const Tagline= styled(Link)`
  color: rgba(0, 0, 0, 0.72);
  font-size: ${fontSizes[3] + 'px'};
  font-family: ${fonts.secondary};
  text-decoration: none;
  word-break: break-word;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
  display: block;
  &:hover {
    color: ${colors.primary};
  }

` 

const TextDetails = styled(Text)`
  list-style: none;
  text-align: left;
  word-break: break-word;
  color: ${colors.greyDark};
  font-family: ${fonts.secondary};
  font-size: ${fontSizes[2] + 'px'};
  padding-bottom: 20px;
`

class Article extends Component {
  render(){
    return(
    <Box width={[1]} p={3}>
    <Box style={{border: `1px solid ${colors.grey}`,borderBottomLeftRadius: '10px',borderBottomRightRadius: '10px'}}>
      <Img
        sizes={this.props.article.frontmatter.cover.childImageSharp.sizes}
        style={{height: "350px"}}
        imgStyle={{objectPosition: 'center center' }}
      />
      <Box px={2}>
      <Flex flexDirection={['column', 'row','column', 'column']} justifyContent="space-between">
        <Flex display="inline">
          <TagMultipleIcon className='IconBox3'/>
          <Iconlink>{`${this.props.article.frontmatter.category}`}</Iconlink>
        </Flex>

        <Flex flexDirection={['column', 'row','row']} >
        <Flex display="inline" pr={3}>
          <AccountIcon className='IconBox3' />
          <Iconlink>{`${this.props.article.frontmatter.author}`}</Iconlink>
        </Flex>
        <Flex display="inline">
          <CalendarIcon className='IconBox3' />
          <Iconlink>{`${this.props.article.frontmatter.dateTime}`}</Iconlink>
        </Flex>
        </Flex>

      </Flex>
      <Tagline to={`${this.props.article.fields.slug}`}>{this.props.article.frontmatter.title}</Tagline>
      <TextDetails dangerouslySetInnerHTML={{ __html: this.props.article.excerpt }}></TextDetails>
      </Box>
    </Box>
    </Box>
  )
}
}

export default Article



// WEBPACK FOOTER //
// ./src/elements/Article.js